import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class UserListService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	listGroup(token) {

		return this.http
			.get(this.apiUrl + "groups/v1/getgroups/?$filter=Ativo eq true and IsProcesso eq false&$orderby=Nome asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
	searchUser(token, userName, userLogin, userGroup, userCompany, userAccess, userStatus, orderby, sort, page) {

		var url = "";
		
		var filter = {
			Ativo: userStatus,
			GrupoID:userGroup,
			TipoAcesso: userAccess,
			EmpresaID: userCompany,
			Usuario: userName,
			Login: userLogin

		}
		
		page = page * globalConst.paginationSkip;
		
		url = "/users/v1/getuser/?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page ;

		return this.http
			.post(this.apiUrl + url,filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/user/service/user-list/user-list.service.ts